import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import saveAs from 'file-saver';
import { first } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ReportsService } from 'src/app/services/reports.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { Location } from '@angular/common'
import { CryptoJsService } from 'src/app/services/crypto-js.service';

@Component({
  selector: 'app-mi-consolidated-detail-report',
  templateUrl: './mi-consolidated-detail-report.component.html',
  styleUrls: ['./mi-consolidated-detail-report.component.scss']
})
export class MiConsolidatedDetailReportComponent implements OnInit {
  @ViewChild('dataTable') tableContainer: ElementRef;
  miUnderProcessReport: MenuItem[];

  public miConsolidatedTableData: any = [];
  public loading: boolean = false;
  public autoId: any = 0;
  public subscriptions: any = [];
  public subjectSub: any;

  public vendorName: any = '';

  constructor(
    private route: ActivatedRoute,
    private reportsService: ReportsService,
    private router: Router,
    private location: Location,
    private loader: AppLoaderService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const isVendorLogin = loginDetails.get('isVendor') ? loginDetails.get('isVendor') : null;

    if(isVendorLogin == '1'){
      const encData = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
      const loginDetails = new Map(encData);
 
      const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
      this.vendorName = tokenInfo['officerName'];
    }else{
      this.vendorName = '';
    }
    this.miUnderProcessReport = [
      {
        label: 'Download excel',
        icon: 'pi pi-fw pi-download',
        command: () => {
          this.exportExcel(this.miConsolidatedTableData, `MI_Consolidated_Details`);
        },
      },
    ];

    this.loadData('', 0);
  }

  ngOnDestroy() {
    this.loader.close();
    this.subscriptions.forEach((sub) => sub.unsubscribe());
    if (this.subjectSub) {
      this.subjectSub.unsubscribe();
    }
  }

  loadData(finYear, autoId) {
    if (autoId == 0) {
      this.loading = true;
    }
    let sub = this.reportsService
      .getMIAppLevelWiseReport(finYear, autoId, this.vendorName)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loading = false;
          // console.log(data.length, data)
          if (data?.length > 0) {
            this.miConsolidatedTableData = this.miConsolidatedTableData.concat(data);

            const lastAutoId = data[data.length - 1].AutoId;
            this.loadData('', lastAutoId);
          } else {

          }
          // console.log(this.underProcessCount)
        },
        error: (err) => {
          // this.loading = false;
          this.loading = false;

          // this.messageService.add({
          //   severity: 'error',
          //   summary: 'Error Message',
          //   detail: err,
          // });
        },
      });

    this.subscriptions.push(sub);
  }

  exportExcel(modelData, filename) {
    if (!modelData) {
      modelData = [];
    }
    import('xlsx').then((xlsx) => {
      let dataToSave = modelData.map((d: any) => {
        return {
          'App Id': d.AppId,
          'District': d.DistName,
          'Block': d.Block,
          'Village': d.Village,
          'Name': d.Name,
          'Father_name': d.Father_name,
          'Mobile': d.Mobile,
          'Caste': d.Caste_Description,
          'Program_Name': d.Program_Name,
          'Total_Area': d.Total_Area,
          'App_ApprovalStaus': d.App_ApprovalStaus,
          'User_Type': d.User_Type,
          'App_ApprovalUse': d.App_ApprovalUse,
          'Application_Date': d.Application_Date,
          'PreEst_PendingDate': d.PreEst_PendingDate,
          'PreEst_Status': d.PreEst_Status,
          'Est_Status': d.Est_Status,
          'Est_ApprovalStaus': d.Est_ApprovalStaus,
          'Est_Area': d.Est_Area,
          'Est_PendingDate': d.Est_PendingDate,
          'Est_Status_User': d.Est_Status_User,
          'Challan_Status': d.Challan_Status,
          'ChallanDepositDate': d.ChallanDepositDate,
          'Challan_Pending': d.Challan_Pending,
          'BOQ_Status': d.BOQ_Status,
          'BOQ_Amount': d.BOQ_Amount,
          'BOQ_Date': d.BOQ_Date,
          'BOQ_Area': d.BOQ_Area,
          'BOQ_PendingDate': d.BOQ_PendingDate,
          'PV_Status': d.PV_Status,
          'PV_Amount': d.PV_Amount,
          'PV_Area': d.PV_Area,
          'PV_PendingUser': d.PV_PendingUser,
          'PV_Date': d.PV_Date,
          'PV_PendingDate': d.PV_PendingDate,
          'Calc_Status': d.Calc_Status,
          'Calc_Area': d.Calc_Area,
          'Calc_PendingDat': d.Calc_PendingDat,
          'Calc_Amount': d.Calc_Amount,
          'Calc_PendingUse': d.Calc_PendingUse,
          'ReqFinYear': d.ReqFinYear,
          'KYCDate': d.KYCDate,
          'KYCStatus': d.KYCStatus,
        };
      });
      const worksheet = xlsx.utils.json_to_sheet(dataToSave);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer: any = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array',
      });
      this.saveAsExcelFile(excelBuffer, filename);
    });
  }
  saveAsExcelFile(buffer: any, fileName: string): void {
    import('file-saver').then((FileSaver) => {
      let EXCEL_TYPE =
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
      let EXCEL_EXTENSION = '.xlsx';
      const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE,
      });
      saveAs(
        data,
        fileName + '_export_' + new Date().getTime() + EXCEL_EXTENSION
      );
    });
  }

  onClickBack() {
    this.location.back();
  }

}
